import React from "react";
import SwiperCore, { Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";

import { useSnapshot } from "valtio";
import {
    templateStore,
    templateActions,
} from "@pages/Applications/C&C/C&CSetup/templateStore";
import PhoneFrameTwo from "@pages/Applications/C&C/C&CSetup/Common/PhoneFrameTwo";
import { baseURL } from "../../../../Website/constants";
import { ImageDisplay } from "@pages/Applications/C&C/C&CSetup/Common/ImageDisplay";

SwiperCore.use([Autoplay]);

export function AdvertisingImagePreview(): JSX.Element {
    const snap = useSnapshot(templateStore);

    const path = ["template", "Application", "ImagePublicite", "Pubs"];
    const localData: any = templateActions.getNestedObject(path);

    const template: any[] = React.useMemo(() => {
        if (!localData) return [];
        return Array.isArray(localData) ? localData : [localData];
    }, [localData]);

    // Get the full media URL (like in ImageDisplay)
    const getMediaUrl = (url: string) => {
        if (!url) return "";
        if (url.startsWith("http") || url.startsWith("blob:")) return url;
        return `${baseURL}/${snap.iuud}/${url}`;
    };

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "80vh",
                borderLeft: "1px #c6c7c9 solid",
            }}
        >
            <div
                style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "90%",
                }}
            >
                <PhoneFrameTwo>
                    <Swiper
                        // loop={true}
                        // autoplay={{
                        //     delay: 3000,
                        //     disableOnInteraction: false,
                        //     pauseOnMouseEnter: true,
                        // }}
                        onSlideChange={(swiper) => {
                            const currentSlide =
                                swiper.slides[swiper.activeIndex];
                            const video = currentSlide.querySelector(
                                "video"
                            ) as HTMLVideoElement;
                            if (video) {
                                swiper.autoplay.stop();
                                video.currentTime = 0;
                                video.play().then(() => {
                                    video.onended = () => {
                                        swiper.slideNext();
                                        swiper.autoplay.start();
                                    };
                                });
                            } else {
                                swiper.autoplay.start();
                            }
                        }}
                        className="swiper-container"
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        {template.map((item: any, index: number) => {
                            const url = getMediaUrl(item?.Pub?.Url || "");

                            return (
                                <SwiperSlide key={item.id || url || index}>
                                    <div
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <ImageDisplay item={item.Pub} />
                                    </div>
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                </PhoneFrameTwo>
            </div>
        </div>
    );
}
